import PropTypes from 'prop-types';
import React from 'react';

import { FooterLinkType } from '@powdr/model';

import {
  StyledFooterNav, LinkList, LinkItem, FooterLink,
} from './styles';

export const FooterNav = ({ footerLinks = [] }) => (
  <StyledFooterNav role="navigation" aria-label="Footer Site Navigation">
    <LinkList>
      {footerLinks.sort((a, b) => a.weight - b.weight).map((link) => (
        <LinkItem key={link.name}>
          <FooterLink
            className={link.classes}
            title={link.name}
            href={link.link}
            target={link?.linkTarget}
          >
            {link.name}
          </FooterLink>
        </LinkItem>
      ))}
    </LinkList>
  </StyledFooterNav>
);

FooterNav.propTypes = {
  footerLinks: PropTypes.arrayOf(FooterLinkType),
};
